import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {
  LfsaBotonEditarGridComponent
} from 'src/app/shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component';
import {CommonFormService} from 'src/app/shared/utils/common-form.service';
import {UtilsService} from 'src/app/shared/utils/utils.service';
import {moduloVMI} from '../../../diccionarios/moduloVMI';
import {AG_GRID_LOCALE_ES} from '../../../diccionarios/spanishAgGrid';
import {VmiColorPorcentajeService} from '../../../services/administracion/vmi-color-porcentaje.service';
import {ColorModel} from '../../../models/vmi-colorModel';

@Component({
  selector: 'app-vmi-frm-mantenedor-color-porcentaje',
  templateUrl: './vmi-frm-mantenedor-color-porcentaje.component.html',
  styleUrls: ['./vmi-frm-mantenedor-color-porcentaje.component.css']
})
export class VmiFrmMantenedorColorPorcentajeComponent implements OnInit {

  formulario: FormGroup;

  columnDefs: any[];
  rowData: any[] = [];
  frameworkComponents: any;
  gridApi: any;
  gridColumnApi: any;
  rowSelection: any;
  loading: boolean = false;
  listaVacia: boolean = true;

  textBoton: string;
  textoBuscar: string;
  mostrarFormulario: boolean = false;

  modulo: any = {};
  editableForm: boolean = false;

  DAT_TITULOS: any;
  titulo: any;
  AG_GRID_LOCALE_ES: any = {};

  constructor(
    private fb: FormBuilder,
    private _utils: UtilsService,
    private commonFormService: CommonFormService,
    private _color: VmiColorPorcentajeService
  ) {
  }

  ngOnInit(): void {
    this.modulo = moduloVMI;
    this.textBoton = this.modulo.button.buttonsNombre.guardar;
    this.AG_GRID_LOCALE_ES = AG_GRID_LOCALE_ES;
    this.DAT_TITULOS = this.modulo.titulos.colorPorcentaje;
    this.titulo = this.DAT_TITULOS.tituloCardListar;

    this.formulario = this.fb.group({
      colorId: [''],
      colorReferencia: ['', [Validators.required]],
      colorPorcentajeInicio: ['', [Validators.required]],
      colorDescripcion: ['', [Validators.required]],
      colorEstado: ['']
    });

    this.gridComponent();
    this.getAll();
  }

  //*SERVICIOS
  getAll() {
    this._color.getAll().subscribe((res: any[]) => {
      this.loading = false;
      this.rowData = res;
      this.listaVacia = (this.rowData.length === 0) ? true : false;
    }, (err) => {
      console.log(err);
      this.loading = false;
      this.rowData = [];
      this.listaVacia = true;
    });
  }

  gridComponent() {
    this.columnDefs = [
      {
        headerName: 'No',
        field: 'colorId',
        sortable: true,
        filter: true,
        width: 100
      },
      {
        headerName: 'DESCRIPCIÓN',
        field: 'colorDescripcion',
        sortable: true,
        filter: true,
        width: 200
      },
      {
        headerName: 'COD.INTERNO',
        field: 'colorReferencia',
        sortable: true,
        filter: true,
        width: 180
      },
      {
        headerName: 'PORCENTAJE',
        field: 'colorPorcentajeInicio',
        sortable: true,
        filter: true,
        width: 180
      },
      {
        headerName: 'ESTADO',
        field: 'colorEstado',
        sortable: true,
        filter: true,
        width: 180,
        valueGetter: function (data) {
          return data.data.colorEstado === 0 ? 'INACTIVO' : 'ACTIVO'
        }
      },
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        width: 100,
        cellRendererParams: {
          onClick: this.editar.bind(this),
          label: this.modulo.button.buttonsNombre.editar,
          colorBoton: this.modulo.button.buttonsCss.info
        }
      },
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        width: 100,
        cellRendererParams: {
          onClick: this.eliminar.bind(this),
          label: this.modulo.button.buttonsNombre.eliminar,
          colorBoton: this.modulo.button.buttonsCss.danger
        }
      }
    ];
    this.frameworkComponents = {
      buttonRenderer: LfsaBotonEditarGridComponent,
    };
    this.rowSelection = 'multiple';
  }

  onQuickFilterChanged() {
    this.gridApi.setQuickFilter(this.textoBuscar);
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  // nuevo() {
  //   this.commonFormService.abrirFormularioParaGuardar(this);
  //   this.titulo = this.DAT_TITULOS.tituloCardGuardar;
  // }

  editar({rowData}) {
    const color: ColorModel = rowData;
    const obj = {
      colorId: color.colorId,
      colorReferencia: color.colorReferencia,
      colorPorcentajeInicio: color.colorPorcentajeInicio,
      colorDescripcion: color.colorDescripcion,
      colorEstado: color.colorEstado,
    };
    this.commonFormService.abrirFormularioParaEditar(this, obj);
    this.titulo = this.DAT_TITULOS.tituloCardEditar
  }

  eliminar({rowData}) {
    const color: ColorModel = rowData;
    this._utils.confirmarSincronoPromesa({
      title: this.modulo.mensajes.eliminar,
      text: ``,
      action: this.modulo.button.buttonsNombre.eliminar,
      funcion: this._color.delete(color.colorId),
    }).then((res: any) => {
      this.getAll();
    }).catch((err) => {
      console.log(err);
    });
  }

  acciones(event) {
    if (event === 'guardar') {
      if (this.editableForm) {
        this.actualizar();
      } else {
        // this.guardar();
      }
    } else {
      this.regresar();
    }
  }

  // guardar() {
  //   const obj: any = this.formulario.value;
  //   this._utils.confirmarSincronoPromesa({
  //     title: this.modulo.mensajes.guardar,
  //     text: ``,
  //     action: this.modulo.button.buttonsNombre.guardar,
  //     funcion: this._color.create(obj),
  //   }).then((res: any) => {
  //     this.getAll();
  //     this.regresar();
  //   }).catch((err) => {
  //     console.log(err);
  //   });
  // }

  actualizar() {
    let color: ColorModel = Object.assign({}, this.formulario.value);
    this._utils.confirmarSincronoPromesa({
      title: this.modulo.mensajes.actualizar,
      text: ``,
      action: this.modulo.button.buttonsNombre.actualizar,
      funcion: this._color.edit(color),
    }).then((res: any) => {
      this.getAll();
      this.regresar();
    }).catch((err) => {
      console.log(err);
    });
  }

  regresar() {
    this.titulo = this.DAT_TITULOS.tituloCardListar;
    this.commonFormService.limpiarYregrear(this);
  }

}
